<template>
  <div class="topbar rounded bg-primary d-flex align-items-center px-2 flex-shrink-0">
    <span>CTU</span>
    <span class="mx-auto">{{currentTick}}</span>
    <font-awesome-icon icon="signal" size="xs" />
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  data() {
    return {
      currentTick: null
    }
  },
  mounted() {
    var self = this;
    setInterval(function () {
      self.currentTick = self.$moment().format('HH:mm');
    }, 1000);
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
